
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[category]",
      function () {
        return require("private-next-pages/guides/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/[category]"])
      });
    }
  